import { Card, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import UpdatePasswordModal from './modals/UpdatePasswordModal';
import UpdateEmailModal from './modals/UpdateEmailModal';
import UpdatePhoneNumberModal from './modals/UpdatePhoneNumberModal';
import { SVLink } from '../core';

export default function ProfileActions() {
  const [openUpdatePassword, setOpenUpdatePassword] = useState(false);
  const [openUpdateEmail, setOpenUpdateEmail] = useState(false);
  const [openUpdatePhone, setOpenUpdatePhone] = useState(false);

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Actions
      </Typography>
      <Stack spacing={2}>
        <SVLink to="" onClick={() => setOpenUpdatePassword(true)}>
          Reset Password
        </SVLink>
        <SVLink to="" onClick={() => setOpenUpdateEmail(true)}>
          Change Email
        </SVLink>
        <SVLink to="" onClick={() => setOpenUpdatePhone(true)}>
          Change Auth Phone
        </SVLink>
        <UpdatePasswordModal
          open={openUpdatePassword}
          setOpen={setOpenUpdatePassword}
        />
        <UpdateEmailModal open={openUpdateEmail} setOpen={setOpenUpdateEmail} />
        <UpdatePhoneNumberModal
          open={openUpdatePhone}
          setOpen={setOpenUpdatePhone}
        />
      </Stack>
    </Card>
  );
}
